const initialState = {
  //mobility: [],
  loading: false
};

export function fetchMobility(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_MOBILITY.SUCCESS':
      return {
        ...state,
        mobility:  action.mobility.body
      };
    default:
      return state
  }
}

export function saveMobility(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_MOBILITY.SUCCESS':
      return {
        ...state,
        mobility: action.mobility.body,
      };
    default:
      return state
  }
}
